










































import {Vue, Component, Prop} from 'vue-property-decorator';
import AppLink from '@/components/AppLink.vue';
import {ProjectInfoInterface} from '@/interfaces/ProjectInfo';
import BackHomeButton from '@/components/BackHomeButton.vue';

@Component({
    name: 'ProjectInfo',
    components: {BackHomeButton, AppLink},
})
export default class ProjectInfo extends Vue {
    @Prop({required: true}) public projectInfo!: ProjectInfoInterface;

    public get linkExists(): boolean {
        if (this.projectInfo.linkInfo === undefined) {
            return false;
        }

        return Object.keys(this.projectInfo.linkInfo).length > 0;
    }
}
